/** Prefill data encoded in a letter composer's content field. */

/** Prefill data encoded in a form composer's content field. */

/** Parses letter prefill data from a composer content string. */
export function parseLetterComposerContent(content) {
  if (!content) return null;
  try {
    return JSON.parse(content);
  } catch (_unused) {
    return null;
  }
}

/** Parses form prefill data from a composer content string. */
export function parseFormComposerContent(content) {
  if (!content) return null;
  try {
    return JSON.parse(content);
  } catch (_unused2) {
    return null;
  }
}